module.exports = __webpack_public_path__ + "static/media/bg-banner-bottom.805b704d.png";